import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTopOnNavigate - Scrolls to top of page when route changes
 * This ensures that when users click links to navigate, they start at the top of the new page
 */
export default function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // Use instant for immediate scroll on navigation
    });
  }, [pathname]);

  return null;
}
